import {
  type Currency,
  countryDisplayName,
  formatAmountWithUnit,
  type ShippingDestination,
} from "@loot-os/api-contract";
import { Badge } from "@loot-os/ui/components/badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@loot-os/ui/components/table";

/** A read-only view of a destinations list, for a config the page shows but does not edit here. */
export function ShippingDestinationsTable({
  destinations,
  currency,
}: {
  destinations: readonly ShippingDestination[];
  currency: Currency;
}) {
  if (destinations.length === 0) {
    return <p className="text-sm text-muted-foreground">No destinations.</p>;
  }
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Country</TableHead>
          <TableHead>Status</TableHead>
          <TableHead className="text-right">Cost</TableHead>
          <TableHead>Delivery estimate</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {destinations.map((destination) => (
          <TableRow key={destination.countryCode}>
            <TableCell>
              {countryDisplayName(destination.countryCode)}{" "}
              <span className="font-mono text-xs text-muted-foreground">
                {destination.countryCode}
              </span>
            </TableCell>
            <TableCell>
              <Badge variant={destination.enabled ? "default" : "outline"}>
                {destination.enabled ? "enabled" : "disabled"}
              </Badge>
            </TableCell>
            <TableCell className="text-right font-mono text-xs">
              {formatAmountWithUnit(destination.costCents, currency)}
            </TableCell>
            <TableCell className="text-muted-foreground">{destination.deliveryEstimate}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
